export var TrackingViewProps;
(function (TrackingViewProps) {
    TrackingViewProps["PRICEMAP"] = "price_map";
    TrackingViewProps["INFO_VIEW"] = "infoview";
    TrackingViewProps["MAP_VIEW"] = "mapview";
    TrackingViewProps["DISTRIBUTION_TYPE_GLOBAL"] = "2";
    TrackingViewProps["PLATFORM"] = "web";
})(TrackingViewProps || (TrackingViewProps = {}));
export var TrackingViewPropsError;
(function (TrackingViewPropsError) {
    TrackingViewPropsError["ERROR_404"] = "error_not_found";
    TrackingViewPropsError["ERROR_500"] = "error_unavailable_content";
})(TrackingViewPropsError || (TrackingViewPropsError = {}));
